import { AsisstanceEffets } from './assistance.effects';
import { AuthenticationEffets } from './authentication.effects';
import { CambiosMercadoEffects } from './cambios-mercado.effects';
import { CDGProgramEffets, GamificacionEffets } from './cdg-program.effects';
import { ContentManagementEffects } from './content-management-effects';
import { DataUserEffets } from './data-user-effects';
import {
    CancelPedidosEffets,
    EcommerceConfigEffets,
    ObtienePedidosEffets,
    PedidosEffets,
    ProductsListEffets,
    PromosEcommerceEffets,
    SendWebhookEffets,
} from './ecommerce.effects';
import { GetmTiendaEffects } from './getm-ecommerce.effects';
import { EjecucionEffets } from './ejecucion.effects';
import { EnfriadoresEffects } from './enfriadores.effects';
import { EnkoEffets } from './enko.effects';
import { GamesEffets } from './games.effects';
import { LegalsEffets } from './legals.effects';
import { NotificationsEffets } from './notifications.effects';
import { ParaTiEffets } from './parati.effects';
import { PopUpEffects } from './popup.effects';
import { PremiadosEffets } from './premiados.effects';
import { ProfileEffects } from './profile.effects';
import { RecompepsiEffects } from './recompepsi.effects';
import { ResetUserEffets } from './reset-user.effect';
import { VentasTicketsEffets } from './ventas-tickets.effects';

export const EffectsArray: any[] = [
    GetmTiendaEffects,
    ProductsListEffets,
    PromosEcommerceEffets,
    PedidosEffets,
    ObtienePedidosEffets,
    EcommerceConfigEffets,
    CancelPedidosEffets,
    NotificationsEffets,
    CDGProgramEffets,
    ParaTiEffets,
    AsisstanceEffets,
    GamesEffets,
    DataUserEffets,
    LegalsEffets,
    EjecucionEffets,
    VentasTicketsEffets,
    ProfileEffects,
    AuthenticationEffets,
    ResetUserEffets,
    EnkoEffets,
    SendWebhookEffets,
    GamificacionEffets,
    PremiadosEffets,
    PopUpEffects,
    EnfriadoresEffects,
    CambiosMercadoEffects,
    RecompepsiEffects,
    ContentManagementEffects
];
